import { useState } from 'react';
import { Color, fill, Size, t } from '@bms2/shared';
import { Button, Dropdown } from '../../components/controls';
import { post } from './api';
import { useEmploymentSearch } from './DealModals';
import { SERVICE_REQUESTS_PATH } from './ServiceRequestFields';
import styles from './DealRequestBand.module.css';

/** 🔨 Relative to the API's own root: Name the Owner on one request or older emergency (decisions 1914, 1992). */
export function nameOwnerPath(dealId: string): string {
  return `${SERVICE_REQUESTS_PATH}/${dealId}/owner`;
}

/**
 * 🔒 Name the Owner (decisions 1914, 1992): drawn on a request whose account named
 * no rep, and on an emergency confirmed before the request row, both still owned
 * by whoever took the call. The invoice from the job refuses to issue until a
 * person names the owner here, from the people employed here and nobody else.
 */
export function DealNameOwner({ dealId, ownerName, writes, apiBaseUrl = '', onSaved, onError }: { dealId: string; ownerName: string | null; writes: boolean; apiBaseUrl?: string; onSaved: () => void; onError: (message: string) => void }) {
  const search = useEmploymentSearch(apiBaseUrl, null, null, 'staff');
  const [chosen, setChosen] = useState<{ id: string; name: string } | null>(null);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!chosen) return;
    setBusy(true);
    const answer = await post<{ ownerPersonId: string }>(nameOwnerPath(dealId), { employmentId: chosen.id }, apiBaseUrl);
    setBusy(false);
    if (!answer.ok) return onError(answer.message);
    onSaved();
  };
  return (
    <section className={styles.band} data-deal-name-owner="true">
      <h3 className={styles.title}>{t('deal.request.ownerWaitingTitle')}</h3>
      <p className={styles.hint}>{fill(t('deal.request.ownerWaiting'), { name: ownerName ?? t('deal.request.ownerSomebody') })}</p>
      {writes ? (
        <div className={styles.actions}>
          <Dropdown size={Size.Medium} label={t('deal.request.owner')} entityLabel={t('deal.request.ownerEntity')} search={search} value={chosen?.name ?? null} onSelect={(row) => setChosen({ id: row.id, name: row.line1 })} onAddNew={null} />
          <Button size={Size.Medium} color={Color.Navy} text={[t('deal.request.nameOwner')]} actions={[() => void save()]} disabled={busy || chosen === null} disabledReason={busy ? t('deal.request.working') : t('deal.request.ownerPick')} />
        </div>
      ) : null}
    </section>
  );
}
